import request from "@/utils/request";

/**
 * 获取用户信息
 */
export function getVersion() {
  return request({
    url: "/pc/upgrade/lasted",
    method: "get",
    params: {
      platform: "3",
      appsource: process.env.VUE_APP_ENV === "nx" ? 100 : 1,
    },
  });
}
